import { jwtDecode, JwtPayload } from "jwt-decode";

const selectAccessTokenData = (accessToken: string) =>
  jwtDecode<{
    userId: string;
    role: string;
    id: string;
    switchInfoId?: string;
    switchInfoIndex?: number;
    switchInfoLength?: number;
    iat: NonNullable<JwtPayload["iat"]>;
    exp: NonNullable<JwtPayload["exp"]>;
  }>(accessToken);

export default selectAccessTokenData;
